export const formatSize = (value) => {
  if (!value) return undefined;
  if (typeof value === 'string') return value;
  return `${value}px`;
};

export const getSelectionStyle = (enabled, isSelected, isHovered) => {
  if (!enabled) return {};

  if (isSelected) {
    return {
      outline: '1px dashed #2196f3',
      outlineOffset: '2px'
    };
  }
  if (isHovered) {
    return {
      outline: '1px dashed #ff9800',
      outlineOffset: '1px'
    };
  }
  return {};
};

export const getPositionStyle = ({ position, top, left, right, bottom, unit, lockedEdges }) => {
  if (position === 'absolute' || position === 'relative') {
    const positionStyle = { position };

    if (lockedEdges.top && top !== undefined) {
      positionStyle.top = `${top}${unit}`;
    }
    if (lockedEdges.left && left !== undefined) {
      positionStyle.left = `${left}${unit}`;
    }
    if (lockedEdges.right && right !== undefined) {
      positionStyle.right = `${right}${unit}`;
    }
    if (lockedEdges.bottom && bottom !== undefined) {
      positionStyle.bottom = `${bottom}${unit}`;
    }

    return positionStyle;
  }
  return { position };
};